import Image from 'next/image'
import clsx from 'clsx'

import Link from '@/atoms/Link/Link'
import { dataLayerPostClickEvent } from '@/utils/functions/dataLayerEvents'

/* styling */
import styles from './_.module.css'

interface TextCardProps {
  title: string
  categories: WpPostCategory[]
  wordCount?: number
  slug: string
}

export const SampleTextCard = (props: TextCardProps) => {
  const handleBlogCardClick = () => {
    dataLayerPostClickEvent({
      title: props.title,
      type: 'sample',
      url: props.slug
    })
  }

  const primaryCategory =
    props.categories.find(category => category.isPrimary)?.node.name ??
    props.categories[0].node.name

  const skillCategory = props.categories.find(category =>
    category.node.name.startsWith('Creator Level: ')
  )?.node.name

  return (
    <Link
      href={props.slug}
      onClick={handleBlogCardClick}
      className={clsx(
        'block  |  border border-gray-20 rounded-lg  |  p-4  |  h-full  |  focus:outline-none focus:ring',
        styles.sampleCard
      )}
    >
      <div>
        <p className="text-small text-purple-50  |  mb-1">{primaryCategory}</p>
        <h3 className="text-paragraph-4 font-medium text-gray-80  |  mb-1">
          {props.title}
        </h3>
        <div className="text-small">
          {skillCategory && (
            <span className="text-gray-80">
              {skillCategory.split('Creator Level: ')[1] + ' Skill'}
            </span>
          )}
          {skillCategory && props.wordCount && (
            <span className="text-caption text-gray-50  |  mx-2">•</span>
          )}
          {props.wordCount && (
            <span className="text-gray-50">{props.wordCount} words</span>
          )}
        </div>
      </div>
    </Link>
  )
}

interface DesignCardProps {
  title: string
  categories: WpPostCategory[]
  slug: string
  imageLink: string
  imageWidth: number
  imageHeight: number
}

export const SampleDesignCard = (props: DesignCardProps) => {
  const primaryCategory =
    props.categories.find(category => category.isPrimary)?.node.name ??
    props.categories[0].node.name
  const handleBlogCardClick = () => {
    dataLayerPostClickEvent({
      title: props.title,
      type: 'sample',
      url: props.slug
    })
  }

  return (
    <Link
      href={props.slug}
      onClick={handleBlogCardClick}
      className={clsx(
        'block  |  border border-gray-20 rounded-lg  |  h-auto  |  focus:outline-none focus:ring',
        styles.sampleCard
      )}
    >
      <div>
        <Image
          alt={props.title}
          src={props.imageLink}
          width={props.imageWidth}
          height={props.imageHeight}
          className="rounded-t-lg  |  w-full"
        />
        <div className="py-2 px-4">
          <h3 className="text-small lg:text-paragraph-4 font-medium text-gray-80  |  mb-0.5">
            {props.title}
          </h3>
          <p className="text-small text-gray-70  |  overflow-x-hidden whitespace-nowrap text-ellipsis">
            {primaryCategory}
          </p>
        </div>
      </div>
    </Link>
  )
}
